import { render, staticRenderFns } from "./SlideCustomer.vue?vue&type=template&id=854009aa&scoped=true"
import script from "./SlideCustomer.vue?vue&type=script&lang=js"
export * from "./SlideCustomer.vue?vue&type=script&lang=js"
import style0 from "./SlideCustomer.vue?vue&type=style&index=0&id=854009aa&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "854009aa",
  null
  
)

export default component.exports